import { win } from '../utils/win';

export const hasDebugParam = (): boolean =>
  typeof URLSearchParams !== 'undefined' &&
  new URLSearchParams(win?.location?.search).has('debug');
